var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
export {
  freeGlobal as default
};
